export enum ZervantContactType {
  Company = 'c',
  Person = 'p',
}
